export const generateShippingPlanSizeMsg = (numericalPlanSize: number): string => {
  const words = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];
  let planSizeMsg: string;

  if (numericalPlanSize === 1) {
    planSizeMsg = words[numericalPlanSize] + ' item';
  } else if (numericalPlanSize <= 10) {
    planSizeMsg = words[numericalPlanSize] + ' items';
  } else {
    planSizeMsg = 'Your items';
  }

  return planSizeMsg;
};

export const handleSlideDown = (popupRef: React.RefObject<HTMLDivElement>, decreaseBy: number): void => {
  const popupElement = popupRef.current;
  // Calculate the initial height based on scrollHeight
  const initialHeight = popupElement.scrollHeight;

  // Apply the initial height to the style
  popupElement.style.height = initialHeight + 'px';
  popupElement.style.overflow = 'hidden';

  // Use requestAnimationFrame for a smooth slide-down animation
  const slideDown = (): void => {
    let currentHeight = parseFloat(popupElement.style.height);

    currentHeight -= decreaseBy;

    if (currentHeight > 0) {
      popupElement.style.height = currentHeight + 'px';
      // Request the next frame
      requestAnimationFrame(slideDown);
    } else {
      // Ensure the final height is set to 0 and overflow is hidden
      popupElement.style.height = '0';
      popupElement.style.overflow = 'hidden';
    }
  };

  // Start the slide-down animation
  slideDown();
};

export const handlSlideUp = (popupRef: React.RefObject<HTMLDivElement>, increaseBy: number): void => {
  const popupElement = popupRef.current;
  // Calculate the height of the popup content
  const contentHeight = popupElement.scrollHeight;

  // Set the initial height to 0 and overflow to hidden
  popupElement.style.height = '0';
  popupElement.style.overflow = 'hidden';

  // Use requestAnimationFrame for a smooth slide-Up animation
  const slideUp = (): void => {
    let currentHeight = parseFloat(popupElement.style.height);

    if (currentHeight < contentHeight) {
      // Increase the height gradually
      currentHeight += increaseBy;
      popupElement.style.height = currentHeight + 'px';

      // Request the next frame
      requestAnimationFrame(slideUp);
    }
  };

  // Start the slide-Up animation
  slideUp();
};
